import { useState, useEffect } from "react";
import { Alert, Box, Button, CircularProgress, Snackbar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { MixpanelWrapper } from "../MixPanelWrapper";
import { useDispatch } from "react-redux";
import { setQuoteGroup, setQuoteId } from "../../services/features/quoteSlice/quoteSlice";
import { GENERIC_ERROR } from "../../helper/constants";

/**
 * Component for rendering a button to load and edit a quote group.
 *
 * This component displays a button that, when clicked, loads a quote group
 * and allows the user to edit it. It handles loading state, error handling,
 * and uses Mixpanel for tracking the "Open Quote" event.
 *
 * @param {object} props - Props for the component.
 * @param {string} props.quoteRow - The ID of the quote group to load and edit.
 * @param {boolean} props.loadingQuote - A boolean indicating if the quote is currently being loaded.
 * @param {Function} props.setLoadingQuote - A function to set the loading state of the quote.
 *
 * @returns {JSX.Element} The rendered button component.
 */
export const LoadQuoteButton = (props: any) => {
	let navigate = useNavigate();
	
	const [snackbarOpen, setSnackbarOpen] = useState(false);

    const dispatch = useDispatch();
    
	const editQuoteRoute = async () => {
		try {
            dispatch(setQuoteGroup(undefined));
            // console.log('Set quote group to undefined', 'props.quoteRow.id', props.quoteRow.id);
            dispatch(setQuoteId(props.quoteRow.id));
			MixpanelWrapper.track("Open Quote", {
				"Insured Name": props.quoteRow.clientHash ?? "",//quote.quoteClient.organizationName,
				Status: props.quoteRow.quotes[0].status ?? "",
			});
			navigate("/create-quote", { state: { createQuote: false } });
		} catch (error) {
			console.log(error);
			setSnackbarOpen(true);
		}
	};

	return (
		<>
			<Button
				variant="contained"
				color="secondary"
				disabled={props.loadingQuote}
				onClick={editQuoteRoute}
			>
				{props.loadingQuote ? (
					<CircularProgress
                    size={"1.6em"}
                    sx={{ color: "white" }}
                />
				) : (
					"Open"
				)}
			</Button>
			{/* Show alert snackbar if there is an error loading quote */}
			<Snackbar
				anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
				onClose={() => setSnackbarOpen(false)}
				autoHideDuration={6000}
				open={snackbarOpen}
			>
				<Alert
					severity="error"
					onClose={() => setSnackbarOpen(false)}
				>{`Error opening quote group ${props.quoteId}; ${GENERIC_ERROR}`}</Alert>
			</Snackbar>
		</>
	);
};
